<span [class]="pillClasses()"><ng-content /></span>
